module.exports = __webpack_public_path__ + "assets/img/23.5eefe12b.png";